// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file analytics/v2/service.proto (package analytics.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc, serviceDesc } from '@bufbuild/protobuf/codegenv2'
import type {
  CompetitiveBenchmarkingData,
  Coordinate,
  CountData,
  DateRangeData,
  DateRangePixelsData,
  DateRangePixelsTotals,
  DateRangeTotals,
  EventType,
  GeoAdministrationLevel,
  GeoJson,
  Interval,
  OrgActivityData,
  Pagination,
  Product,
  RangeSummaryData,
  RawEventsCol,
  RawEventsData,
  ScatterPlotCoordinate,
  SummaryData,
  SummaryPixelsData,
  TopCitiesData,
  TopCodesData,
  TopCodesPixelsData,
  TopDaysData,
  TopDestinationsData,
  TopDevicesData,
  TopHoursData,
  TopLinksData,
  TopOperatingSystemsData,
  TopPagesData,
  TopPathsPixelsData,
  TopStatesData,
  TopTagsData,
  TopUTMCampaignsData,
  TopUTMReferrersData,
  TopUTMTermsData
} from './analytics_pb'
import { file_analytics_v2_analytics } from './analytics_pb'
import { file_google_api_annotations } from '../../google/api/annotations_pb'
import { file_common_v1_annotations } from '../../common/v1/annotations_pb'
import { file_buf_validate_validate } from '../../buf/validate/validate_pb'
import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file analytics/v2/service.proto.
 */
export const file_analytics_v2_service: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_analytics_v2_analytics,
      file_google_api_annotations,
      file_common_v1_annotations,
      file_buf_validate_validate,
      file_google_protobuf_timestamp
    ]
  )

/**
 * Healthcheck
 *
 * @generated from message analytics.v2.HealthCheckRequest
 */
export type HealthCheckRequest = Message<'analytics.v2.HealthCheckRequest'> & {}

/**
 * Describes the message analytics.v2.HealthCheckRequest.
 * Use `create(HealthCheckRequestSchema)` to create a new message.
 */
export const HealthCheckRequestSchema: GenMessage<HealthCheckRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 0)

/**
 * @generated from message analytics.v2.HealthCheckResponse
 */
export type HealthCheckResponse = Message<'analytics.v2.HealthCheckResponse'> & {}

/**
 * Describes the message analytics.v2.HealthCheckResponse.
 * Use `create(HealthCheckResponseSchema)` to create a new message.
 */
export const HealthCheckResponseSchema: GenMessage<HealthCheckResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 1)

/**
 * Audience Insights
 * No params in request bc just need ithaca_id
 *
 * @generated from message analytics.v2.CompetitiveBenchmarkingRequest
 */
export type CompetitiveBenchmarkingRequest =
  Message<'analytics.v2.CompetitiveBenchmarkingRequest'> & {}

/**
 * Describes the message analytics.v2.CompetitiveBenchmarkingRequest.
 * Use `create(CompetitiveBenchmarkingRequestSchema)` to create a new message.
 */
export const CompetitiveBenchmarkingRequestSchema: GenMessage<CompetitiveBenchmarkingRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 2)

/**
 * @generated from message analytics.v2.CompetitiveBenchmarkingResponse
 */
export type CompetitiveBenchmarkingResponse =
  Message<'analytics.v2.CompetitiveBenchmarkingResponse'> & {
    /**
     * @generated from field: analytics.v2.CompetitiveBenchmarkingData data = 1;
     */
    data?: CompetitiveBenchmarkingData
  }

/**
 * Describes the message analytics.v2.CompetitiveBenchmarkingResponse.
 * Use `create(CompetitiveBenchmarkingResponseSchema)` to create a new message.
 */
export const CompetitiveBenchmarkingResponseSchema: GenMessage<CompetitiveBenchmarkingResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 3)

/**
 * Range summary
 *
 * @generated from message analytics.v2.RangeSummaryRequest
 */
export type RangeSummaryRequest = Message<'analytics.v2.RangeSummaryRequest'> & {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product: Product

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[]

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp

  /**
   * @generated from field: string timezone = 5;
   */
  timezone: string

  /**
   * @generated from field: bool all_assets = 6;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 7;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 8;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 9;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 10;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 11;
   */
  tagName: string[]
}

/**
 * Describes the message analytics.v2.RangeSummaryRequest.
 * Use `create(RangeSummaryRequestSchema)` to create a new message.
 */
export const RangeSummaryRequestSchema: GenMessage<RangeSummaryRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 4)

/**
 * @generated from message analytics.v2.RangeSummaryResponse
 */
export type RangeSummaryResponse = Message<'analytics.v2.RangeSummaryResponse'> & {
  /**
   * @generated from field: analytics.v2.RangeSummaryData data = 1;
   */
  data?: RangeSummaryData
}

/**
 * Describes the message analytics.v2.RangeSummaryResponse.
 * Use `create(RangeSummaryResponseSchema)` to create a new message.
 */
export const RangeSummaryResponseSchema: GenMessage<RangeSummaryResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 5)

/**
 * Summary
 *
 * @generated from message analytics.v2.SummaryRequest
 */
export type SummaryRequest = Message<'analytics.v2.SummaryRequest'> & {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product: Product

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[]

  /**
   * @generated from field: string timezone = 3;
   */
  timezone: string

  /**
   * @generated from field: bool all_assets = 4;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 5;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 6;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 7;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 8;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 9;
   */
  tagName: string[]
}

/**
 * Describes the message analytics.v2.SummaryRequest.
 * Use `create(SummaryRequestSchema)` to create a new message.
 */
export const SummaryRequestSchema: GenMessage<SummaryRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 6)

/**
 * @generated from message analytics.v2.SummaryResponse
 */
export type SummaryResponse = Message<'analytics.v2.SummaryResponse'> & {
  /**
   * @generated from field: analytics.v2.SummaryData data = 1;
   */
  data?: SummaryData
}

/**
 * Describes the message analytics.v2.SummaryResponse.
 * Use `create(SummaryResponseSchema)` to create a new message.
 */
export const SummaryResponseSchema: GenMessage<SummaryResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 7)

/**
 * @generated from message analytics.v2.SummaryPixelsRequest
 */
export type SummaryPixelsRequest = Message<'analytics.v2.SummaryPixelsRequest'> & {
  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 1;
   */
  eventType: EventType[]

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp

  /**
   * @generated from field: string timezone = 4;
   */
  timezone: string

  /**
   * @generated from field: bool all_assets = 5;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 6;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 7;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 8;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 9;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 10;
   */
  tagName: string[]

  /**
   * @generated from field: repeated string app_id = 11;
   */
  appId: string[]
}

/**
 * Describes the message analytics.v2.SummaryPixelsRequest.
 * Use `create(SummaryPixelsRequestSchema)` to create a new message.
 */
export const SummaryPixelsRequestSchema: GenMessage<SummaryPixelsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 8)

/**
 * @generated from message analytics.v2.SummaryPixelsResponse
 */
export type SummaryPixelsResponse = Message<'analytics.v2.SummaryPixelsResponse'> & {
  /**
   * @generated from field: analytics.v2.SummaryPixelsData data = 1;
   */
  data?: SummaryPixelsData
}

/**
 * Describes the message analytics.v2.SummaryPixelsResponse.
 * Use `create(SummaryPixelsResponseSchema)` to create a new message.
 */
export const SummaryPixelsResponseSchema: GenMessage<SummaryPixelsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 9)

/**
 * Count
 *
 * @generated from message analytics.v2.CountRequest
 */
export type CountRequest = Message<'analytics.v2.CountRequest'> & {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product: Product

  /**
   * @generated from field: repeated string asset_id = 2;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 3;
   */
  pageId: string[]

  /**
   * @generated from field: bool all_assets = 4;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated int32 directory_id = 5;
   */
  directoryId: number[]
}

/**
 * Describes the message analytics.v2.CountRequest.
 * Use `create(CountRequestSchema)` to create a new message.
 */
export const CountRequestSchema: GenMessage<CountRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 10)

/**
 * @generated from message analytics.v2.CountResponse
 */
export type CountResponse = Message<'analytics.v2.CountResponse'> & {
  /**
   * @generated from field: analytics.v2.CountData data = 1;
   */
  data?: CountData
}

/**
 * Describes the message analytics.v2.CountResponse.
 * Use `create(CountResponseSchema)` to create a new message.
 */
export const CountResponseSchema: GenMessage<CountResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 11)

/**
 * Raw events
 *
 * @generated from message analytics.v2.SortByConfig
 */
export type SortByConfig = Message<'analytics.v2.SortByConfig'> & {
  /**
   * @generated from field: analytics.v2.RawEventsCol field = 1;
   */
  field: RawEventsCol

  /**
   * @generated from field: string direction = 2;
   */
  direction: string
}

/**
 * Describes the message analytics.v2.SortByConfig.
 * Use `create(SortByConfigSchema)` to create a new message.
 */
export const SortByConfigSchema: GenMessage<SortByConfig> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 12)

/**
 * @generated from message analytics.v2.RawEventsDisplayConfig
 */
export type RawEventsDisplayConfig = Message<'analytics.v2.RawEventsDisplayConfig'> & {
  /**
   * @generated from field: repeated analytics.v2.RawEventsCol columns = 1;
   */
  columns: RawEventsCol[]

  /**
   * @generated from field: repeated analytics.v2.SortByConfig sort_by = 2;
   */
  sortBy: SortByConfig[]
}

/**
 * Describes the message analytics.v2.RawEventsDisplayConfig.
 * Use `create(RawEventsDisplayConfigSchema)` to create a new message.
 */
export const RawEventsDisplayConfigSchema: GenMessage<RawEventsDisplayConfig> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 13)

/**
 * @generated from message analytics.v2.RawEventsRequest
 */
export type RawEventsRequest = Message<'analytics.v2.RawEventsRequest'> & {
  /**
   * @generated from field: repeated analytics.v2.Product product = 1;
   */
  product: Product[]

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[]

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp

  /**
   * @generated from field: string timezone = 5;
   */
  timezone: string

  /**
   * @generated from field: bool all_assets = 6;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 7;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 8;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 9;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 10;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 11;
   */
  tagName: string[]

  /**
   * @generated from field: int64 page_size = 12;
   */
  pageSize: bigint

  /**
   * @generated from field: int64 page_num = 13;
   */
  pageNum: bigint

  /**
   * @generated from field: int64 row_limit = 14;
   */
  rowLimit: bigint

  /**
   * @generated from field: analytics.v2.RawEventsDisplayConfig raw_events_display_config = 15;
   */
  rawEventsDisplayConfig?: RawEventsDisplayConfig

  /**
   * @generated from field: repeated string app_id = 16;
   */
  appId: string[]
}

/**
 * Describes the message analytics.v2.RawEventsRequest.
 * Use `create(RawEventsRequestSchema)` to create a new message.
 */
export const RawEventsRequestSchema: GenMessage<RawEventsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 14)

/**
 * @generated from message analytics.v2.RawEventsResponse
 */
export type RawEventsResponse = Message<'analytics.v2.RawEventsResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.RawEventsCol columns = 2;
   */
  columns: RawEventsCol[]

  /**
   * @generated from field: repeated analytics.v2.RawEventsData data = 3;
   */
  data: RawEventsData[]
}

/**
 * Describes the message analytics.v2.RawEventsResponse.
 * Use `create(RawEventsResponseSchema)` to create a new message.
 */
export const RawEventsResponseSchema: GenMessage<RawEventsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 15)

/**
 * Top
 *
 * @generated from message analytics.v2.TopRequest
 */
export type TopRequest = Message<'analytics.v2.TopRequest'> & {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product: Product

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[]

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp

  /**
   * @generated from field: string timezone = 5;
   */
  timezone: string

  /**
   * @generated from field: bool all_assets = 6;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 7;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 8;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 9;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 10;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 11;
   */
  tagName: string[]

  /**
   * @generated from field: int64 page_size = 12;
   */
  pageSize: bigint

  /**
   * @generated from field: int64 page_num = 13;
   */
  pageNum: bigint

  /**
   * @generated from field: repeated string app_id = 14;
   */
  appId: string[]
}

/**
 * Describes the message analytics.v2.TopRequest.
 * Use `create(TopRequestSchema)` to create a new message.
 */
export const TopRequestSchema: GenMessage<TopRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 16)

/**
 * Top Codes
 *
 * @generated from message analytics.v2.TopCodesRequest
 */
export type TopCodesRequest = Message<'analytics.v2.TopCodesRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopCodesRequest.
 * Use `create(TopCodesRequestSchema)` to create a new message.
 */
export const TopCodesRequestSchema: GenMessage<TopCodesRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 17)

/**
 * @generated from message analytics.v2.TopCodesResponse
 */
export type TopCodesResponse = Message<'analytics.v2.TopCodesResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopCodesData data = 2;
   */
  data: TopCodesData[]
}

/**
 * Describes the message analytics.v2.TopCodesResponse.
 * Use `create(TopCodesResponseSchema)` to create a new message.
 */
export const TopCodesResponseSchema: GenMessage<TopCodesResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 18)

/**
 * Top Codes Pixels
 *
 * @generated from message analytics.v2.TopCodesPixelsRequest
 */
export type TopCodesPixelsRequest = Message<'analytics.v2.TopCodesPixelsRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopCodesPixelsRequest.
 * Use `create(TopCodesPixelsRequestSchema)` to create a new message.
 */
export const TopCodesPixelsRequestSchema: GenMessage<TopCodesPixelsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 19)

/**
 * @generated from message analytics.v2.TopCodesPixelsResponse
 */
export type TopCodesPixelsResponse = Message<'analytics.v2.TopCodesPixelsResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopCodesPixelsData data = 2;
   */
  data: TopCodesPixelsData[]
}

/**
 * Describes the message analytics.v2.TopCodesPixelsResponse.
 * Use `create(TopCodesPixelsResponseSchema)` to create a new message.
 */
export const TopCodesPixelsResponseSchema: GenMessage<TopCodesPixelsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 20)

/**
 * Top Paths Pixels
 *
 * @generated from message analytics.v2.TopPathsPixelsRequest
 */
export type TopPathsPixelsRequest = Message<'analytics.v2.TopPathsPixelsRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopPathsPixelsRequest.
 * Use `create(TopPathsPixelsRequestSchema)` to create a new message.
 */
export const TopPathsPixelsRequestSchema: GenMessage<TopPathsPixelsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 21)

/**
 * @generated from message analytics.v2.TopPathsPixelsResponse
 */
export type TopPathsPixelsResponse = Message<'analytics.v2.TopPathsPixelsResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopPathsPixelsData data = 2;
   */
  data: TopPathsPixelsData[]
}

/**
 * Describes the message analytics.v2.TopPathsPixelsResponse.
 * Use `create(TopPathsPixelsResponseSchema)` to create a new message.
 */
export const TopPathsPixelsResponseSchema: GenMessage<TopPathsPixelsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 22)

/**
 * Top Destinations
 *
 * @generated from message analytics.v2.TopDestinationsRequest
 */
export type TopDestinationsRequest = Message<'analytics.v2.TopDestinationsRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopDestinationsRequest.
 * Use `create(TopDestinationsRequestSchema)` to create a new message.
 */
export const TopDestinationsRequestSchema: GenMessage<TopDestinationsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 23)

/**
 * @generated from message analytics.v2.TopDestinationsResponse
 */
export type TopDestinationsResponse = Message<'analytics.v2.TopDestinationsResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopDestinationsData data = 2;
   */
  data: TopDestinationsData[]
}

/**
 * Describes the message analytics.v2.TopDestinationsResponse.
 * Use `create(TopDestinationsResponseSchema)` to create a new message.
 */
export const TopDestinationsResponseSchema: GenMessage<TopDestinationsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 24)

/**
 * Top Pages
 *
 * @generated from message analytics.v2.TopPagesRequest
 */
export type TopPagesRequest = Message<'analytics.v2.TopPagesRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopPagesRequest.
 * Use `create(TopPagesRequestSchema)` to create a new message.
 */
export const TopPagesRequestSchema: GenMessage<TopPagesRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 25)

/**
 * @generated from message analytics.v2.TopPagesResponse
 */
export type TopPagesResponse = Message<'analytics.v2.TopPagesResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopPagesData data = 2;
   */
  data: TopPagesData[]
}

/**
 * Describes the message analytics.v2.TopPagesResponse.
 * Use `create(TopPagesResponseSchema)` to create a new message.
 */
export const TopPagesResponseSchema: GenMessage<TopPagesResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 26)

/**
 * Top Links
 *
 * @generated from message analytics.v2.TopLinksRequest
 */
export type TopLinksRequest = Message<'analytics.v2.TopLinksRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopLinksRequest.
 * Use `create(TopLinksRequestSchema)` to create a new message.
 */
export const TopLinksRequestSchema: GenMessage<TopLinksRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 27)

/**
 * @generated from message analytics.v2.TopLinksResponse
 */
export type TopLinksResponse = Message<'analytics.v2.TopLinksResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopLinksData data = 2;
   */
  data: TopLinksData[]
}

/**
 * Describes the message analytics.v2.TopLinksResponse.
 * Use `create(TopLinksResponseSchema)` to create a new message.
 */
export const TopLinksResponseSchema: GenMessage<TopLinksResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 28)

/**
 * Top UTM Campaigns
 *
 * @generated from message analytics.v2.TopUTMCampaignsRequest
 */
export type TopUTMCampaignsRequest = Message<'analytics.v2.TopUTMCampaignsRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopUTMCampaignsRequest.
 * Use `create(TopUTMCampaignsRequestSchema)` to create a new message.
 */
export const TopUTMCampaignsRequestSchema: GenMessage<TopUTMCampaignsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 29)

/**
 * @generated from message analytics.v2.TopUTMCampaignsResponse
 */
export type TopUTMCampaignsResponse = Message<'analytics.v2.TopUTMCampaignsResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopUTMCampaignsData data = 2;
   */
  data: TopUTMCampaignsData[]
}

/**
 * Describes the message analytics.v2.TopUTMCampaignsResponse.
 * Use `create(TopUTMCampaignsResponseSchema)` to create a new message.
 */
export const TopUTMCampaignsResponseSchema: GenMessage<TopUTMCampaignsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 30)

/**
 * Top UTM Terms
 *
 * @generated from message analytics.v2.TopUTMTermsRequest
 */
export type TopUTMTermsRequest = Message<'analytics.v2.TopUTMTermsRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopUTMTermsRequest.
 * Use `create(TopUTMTermsRequestSchema)` to create a new message.
 */
export const TopUTMTermsRequestSchema: GenMessage<TopUTMTermsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 31)

/**
 * @generated from message analytics.v2.TopUTMTermsResponse
 */
export type TopUTMTermsResponse = Message<'analytics.v2.TopUTMTermsResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopUTMTermsData data = 2;
   */
  data: TopUTMTermsData[]
}

/**
 * Describes the message analytics.v2.TopUTMTermsResponse.
 * Use `create(TopUTMTermsResponseSchema)` to create a new message.
 */
export const TopUTMTermsResponseSchema: GenMessage<TopUTMTermsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 32)

/**
 * Top UTM Referrers
 *
 * @generated from message analytics.v2.TopUTMReferrersRequest
 */
export type TopUTMReferrersRequest = Message<'analytics.v2.TopUTMReferrersRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopUTMReferrersRequest.
 * Use `create(TopUTMReferrersRequestSchema)` to create a new message.
 */
export const TopUTMReferrersRequestSchema: GenMessage<TopUTMReferrersRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 33)

/**
 * @generated from message analytics.v2.TopUTMReferrersResponse
 */
export type TopUTMReferrersResponse = Message<'analytics.v2.TopUTMReferrersResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopUTMReferrersData data = 2;
   */
  data: TopUTMReferrersData[]
}

/**
 * Describes the message analytics.v2.TopUTMReferrersResponse.
 * Use `create(TopUTMReferrersResponseSchema)` to create a new message.
 */
export const TopUTMReferrersResponseSchema: GenMessage<TopUTMReferrersResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 34)

/**
 * Top Cities
 *
 * @generated from message analytics.v2.TopCitiesRequest
 */
export type TopCitiesRequest = Message<'analytics.v2.TopCitiesRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopCitiesRequest.
 * Use `create(TopCitiesRequestSchema)` to create a new message.
 */
export const TopCitiesRequestSchema: GenMessage<TopCitiesRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 35)

/**
 * @generated from message analytics.v2.TopCitiesResponse
 */
export type TopCitiesResponse = Message<'analytics.v2.TopCitiesResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopCitiesData data = 2;
   */
  data: TopCitiesData[]
}

/**
 * Describes the message analytics.v2.TopCitiesResponse.
 * Use `create(TopCitiesResponseSchema)` to create a new message.
 */
export const TopCitiesResponseSchema: GenMessage<TopCitiesResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 36)

/**
 * Top States
 *
 * @generated from message analytics.v2.TopStatesRequest
 */
export type TopStatesRequest = Message<'analytics.v2.TopStatesRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopStatesRequest.
 * Use `create(TopStatesRequestSchema)` to create a new message.
 */
export const TopStatesRequestSchema: GenMessage<TopStatesRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 37)

/**
 * @generated from message analytics.v2.TopStatesResponse
 */
export type TopStatesResponse = Message<'analytics.v2.TopStatesResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopStatesData data = 2;
   */
  data: TopStatesData[]
}

/**
 * Describes the message analytics.v2.TopStatesResponse.
 * Use `create(TopStatesResponseSchema)` to create a new message.
 */
export const TopStatesResponseSchema: GenMessage<TopStatesResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 38)

/**
 * Top Days
 *
 * @generated from message analytics.v2.TopDaysRequest
 */
export type TopDaysRequest = Message<'analytics.v2.TopDaysRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopDaysRequest.
 * Use `create(TopDaysRequestSchema)` to create a new message.
 */
export const TopDaysRequestSchema: GenMessage<TopDaysRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 39)

/**
 * @generated from message analytics.v2.TopDaysResponse
 */
export type TopDaysResponse = Message<'analytics.v2.TopDaysResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopDaysData data = 2;
   */
  data: TopDaysData[]
}

/**
 * Describes the message analytics.v2.TopDaysResponse.
 * Use `create(TopDaysResponseSchema)` to create a new message.
 */
export const TopDaysResponseSchema: GenMessage<TopDaysResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 40)

/**
 * Top Hours
 *
 * @generated from message analytics.v2.TopHoursRequest
 */
export type TopHoursRequest = Message<'analytics.v2.TopHoursRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopHoursRequest.
 * Use `create(TopHoursRequestSchema)` to create a new message.
 */
export const TopHoursRequestSchema: GenMessage<TopHoursRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 41)

/**
 * @generated from message analytics.v2.TopHoursResponse
 */
export type TopHoursResponse = Message<'analytics.v2.TopHoursResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopHoursData data = 2;
   */
  data: TopHoursData[]
}

/**
 * Describes the message analytics.v2.TopHoursResponse.
 * Use `create(TopHoursResponseSchema)` to create a new message.
 */
export const TopHoursResponseSchema: GenMessage<TopHoursResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 42)

/**
 * Top Devices
 *
 * @generated from message analytics.v2.TopDevicesRequest
 */
export type TopDevicesRequest = Message<'analytics.v2.TopDevicesRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopDevicesRequest.
 * Use `create(TopDevicesRequestSchema)` to create a new message.
 */
export const TopDevicesRequestSchema: GenMessage<TopDevicesRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 43)

/**
 * @generated from message analytics.v2.TopDevicesResponse
 */
export type TopDevicesResponse = Message<'analytics.v2.TopDevicesResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopDevicesData data = 2;
   */
  data: TopDevicesData[]
}

/**
 * Describes the message analytics.v2.TopDevicesResponse.
 * Use `create(TopDevicesResponseSchema)` to create a new message.
 */
export const TopDevicesResponseSchema: GenMessage<TopDevicesResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 44)

/**
 * Top Operating Systems
 *
 * @generated from message analytics.v2.TopOperatingSystemsRequest
 */
export type TopOperatingSystemsRequest = Message<'analytics.v2.TopOperatingSystemsRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopOperatingSystemsRequest.
 * Use `create(TopOperatingSystemsRequestSchema)` to create a new message.
 */
export const TopOperatingSystemsRequestSchema: GenMessage<TopOperatingSystemsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 45)

/**
 * @generated from message analytics.v2.TopOperatingSystemsResponse
 */
export type TopOperatingSystemsResponse = Message<'analytics.v2.TopOperatingSystemsResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopOperatingSystemsData data = 2;
   */
  data: TopOperatingSystemsData[]
}

/**
 * Describes the message analytics.v2.TopOperatingSystemsResponse.
 * Use `create(TopOperatingSystemsResponseSchema)` to create a new message.
 */
export const TopOperatingSystemsResponseSchema: GenMessage<TopOperatingSystemsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 46)

/**
 * Top Tags
 *
 * @generated from message analytics.v2.TopTagsRequest
 */
export type TopTagsRequest = Message<'analytics.v2.TopTagsRequest'> & {
  /**
   * @generated from field: analytics.v2.TopRequest top_request = 1;
   */
  topRequest?: TopRequest
}

/**
 * Describes the message analytics.v2.TopTagsRequest.
 * Use `create(TopTagsRequestSchema)` to create a new message.
 */
export const TopTagsRequestSchema: GenMessage<TopTagsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 47)

/**
 * @generated from message analytics.v2.TopTagsResponse
 */
export type TopTagsResponse = Message<'analytics.v2.TopTagsResponse'> & {
  /**
   * @generated from field: analytics.v2.Pagination pagination = 1;
   */
  pagination?: Pagination

  /**
   * @generated from field: repeated analytics.v2.TopTagsData data = 2;
   */
  data: TopTagsData[]
}

/**
 * Describes the message analytics.v2.TopTagsResponse.
 * Use `create(TopTagsResponseSchema)` to create a new message.
 */
export const TopTagsResponseSchema: GenMessage<TopTagsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 48)

/**
 * Date Range
 *
 * @generated from message analytics.v2.DateRangeRequest
 */
export type DateRangeRequest = Message<'analytics.v2.DateRangeRequest'> & {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product: Product

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[]

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp

  /**
   * @generated from field: analytics.v2.Interval interval = 5;
   */
  interval: Interval

  /**
   * @generated from field: string timezone = 6;
   */
  timezone: string

  /**
   * @generated from field: bool all_assets = 7;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 8;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 9;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 10;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 11;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 12;
   */
  tagName: string[]
}

/**
 * Describes the message analytics.v2.DateRangeRequest.
 * Use `create(DateRangeRequestSchema)` to create a new message.
 */
export const DateRangeRequestSchema: GenMessage<DateRangeRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 49)

/**
 * @generated from message analytics.v2.DateRangeResponse
 */
export type DateRangeResponse = Message<'analytics.v2.DateRangeResponse'> & {
  /**
   * @generated from field: repeated analytics.v2.DateRangeData data = 1;
   */
  data: DateRangeData[]

  /**
   * @generated from field: analytics.v2.DateRangeTotals totals = 2;
   */
  totals?: DateRangeTotals
}

/**
 * Describes the message analytics.v2.DateRangeResponse.
 * Use `create(DateRangeResponseSchema)` to create a new message.
 */
export const DateRangeResponseSchema: GenMessage<DateRangeResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 50)

/**
 * Date Range Pixels
 *
 * @generated from message analytics.v2.DateRangePixelsRequest
 */
export type DateRangePixelsRequest = Message<'analytics.v2.DateRangePixelsRequest'> & {
  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 1;
   */
  eventType: EventType[]

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 2;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */
  endDate?: Timestamp

  /**
   * @generated from field: analytics.v2.Interval interval = 4;
   */
  interval: Interval

  /**
   * @generated from field: string timezone = 5;
   */
  timezone: string

  /**
   * @generated from field: bool all_assets = 6;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 7;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 8;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 9;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 10;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 11;
   */
  tagName: string[]

  /**
   * @generated from field: repeated string app_id = 12;
   */
  appId: string[]
}

/**
 * Describes the message analytics.v2.DateRangePixelsRequest.
 * Use `create(DateRangePixelsRequestSchema)` to create a new message.
 */
export const DateRangePixelsRequestSchema: GenMessage<DateRangePixelsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 51)

/**
 * @generated from message analytics.v2.DateRangePixelsResponse
 */
export type DateRangePixelsResponse = Message<'analytics.v2.DateRangePixelsResponse'> & {
  /**
   * @generated from field: repeated analytics.v2.DateRangePixelsData data = 1;
   */
  data: DateRangePixelsData[]

  /**
   * @generated from field: analytics.v2.DateRangePixelsTotals totals = 2;
   */
  totals?: DateRangePixelsTotals
}

/**
 * Describes the message analytics.v2.DateRangePixelsResponse.
 * Use `create(DateRangePixelsResponseSchema)` to create a new message.
 */
export const DateRangePixelsResponseSchema: GenMessage<DateRangePixelsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 52)

/**
 * Download, works with pixels
 *
 * @generated from message analytics.v2.DownloadRequest
 */
export type DownloadRequest = Message<'analytics.v2.DownloadRequest'> & {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product: Product

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[]

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp

  /**
   * @generated from field: analytics.v2.Interval interval = 5;
   */
  interval: Interval

  /**
   * @generated from field: string timezone = 6;
   */
  timezone: string

  /**
   * @generated from field: bool all_assets = 7;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 8;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 9;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 10;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 11;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 12;
   */
  tagName: string[]
}

/**
 * Describes the message analytics.v2.DownloadRequest.
 * Use `create(DownloadRequestSchema)` to create a new message.
 */
export const DownloadRequestSchema: GenMessage<DownloadRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 53)

/**
 * @generated from message analytics.v2.DownloadResponse
 */
export type DownloadResponse = Message<'analytics.v2.DownloadResponse'> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array
}

/**
 * Describes the message analytics.v2.DownloadResponse.
 * Use `create(DownloadResponseSchema)` to create a new message.
 */
export const DownloadResponseSchema: GenMessage<DownloadResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 54)

/**
 * Raw events download, works with pixels
 *
 * @generated from message analytics.v2.DownloadRawEventsRequest
 */
export type DownloadRawEventsRequest = Message<'analytics.v2.DownloadRawEventsRequest'> & {
  /**
   * @generated from field: analytics.v2.RawEventsRequest request = 1;
   */
  request?: RawEventsRequest
}

/**
 * Describes the message analytics.v2.DownloadRawEventsRequest.
 * Use `create(DownloadRawEventsRequestSchema)` to create a new message.
 */
export const DownloadRawEventsRequestSchema: GenMessage<DownloadRawEventsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 55)

/**
 * @generated from message analytics.v2.DownloadRawEventsResponse
 */
export type DownloadRawEventsResponse = Message<'analytics.v2.DownloadRawEventsResponse'> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array
}

/**
 * Describes the message analytics.v2.DownloadRawEventsResponse.
 * Use `create(DownloadRawEventsResponseSchema)` to create a new message.
 */
export const DownloadRawEventsResponseSchema: GenMessage<DownloadRawEventsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 56)

/**
 * Geo
 *
 * @generated from message analytics.v2.GeoAdminLevelRequest
 */
export type GeoAdminLevelRequest = Message<'analytics.v2.GeoAdminLevelRequest'> & {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product: Product

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[]

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp

  /**
   * @generated from field: repeated analytics.v2.Coordinate viewport = 5;
   */
  viewport: Coordinate[]

  /**
   * @generated from field: analytics.v2.GeoAdministrationLevel geo_administration_level = 6;
   */
  geoAdministrationLevel: GeoAdministrationLevel

  /**
   * @generated from field: bool all_assets = 7;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 8;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 9;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 10;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 11;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 12;
   */
  tagName: string[]

  /**
   * @generated from field: bool geo_low_res = 13 [deprecated = true];
   * @deprecated
   */
  geoLowRes: boolean
}

/**
 * Describes the message analytics.v2.GeoAdminLevelRequest.
 * Use `create(GeoAdminLevelRequestSchema)` to create a new message.
 */
export const GeoAdminLevelRequestSchema: GenMessage<GeoAdminLevelRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 57)

/**
 * @generated from message analytics.v2.GeoAdminLevelResponse
 */
export type GeoAdminLevelResponse = Message<'analytics.v2.GeoAdminLevelResponse'> & {
  /**
   * @generated from field: int32 maximum_count = 1;
   */
  maximumCount: number

  /**
   * @generated from field: int32 interstitial_count = 2;
   */
  interstitialCount: number

  /**
   * @generated from field: int32 ip_to_geo_count = 3;
   */
  ipToGeoCount: number

  /**
   * @generated from field: analytics.v2.GeoJson geo_json = 4;
   */
  geoJson?: GeoJson
}

/**
 * Describes the message analytics.v2.GeoAdminLevelResponse.
 * Use `create(GeoAdminLevelResponseSchema)` to create a new message.
 */
export const GeoAdminLevelResponseSchema: GenMessage<GeoAdminLevelResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 58)

/**
 * @generated from message analytics.v2.GeoScatterPlotRequest
 */
export type GeoScatterPlotRequest = Message<'analytics.v2.GeoScatterPlotRequest'> & {
  /**
   * @generated from field: analytics.v2.Product product = 1;
   */
  product: Product

  /**
   * @generated from field: repeated analytics.v2.EventType event_type = 2;
   */
  eventType: EventType[]

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 3;
   */
  startDate?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 4;
   */
  endDate?: Timestamp

  /**
   * @generated from field: repeated analytics.v2.Coordinate viewport = 5;
   */
  viewport: Coordinate[]

  /**
   * @generated from field: analytics.v2.GeoAdministrationLevel geo_administration_level = 6;
   */
  geoAdministrationLevel: GeoAdministrationLevel

  /**
   * @generated from field: bool all_assets = 7;
   */
  allAssets: boolean

  /**
   * @generated from field: repeated string team_id = 8;
   */
  teamId: string[]

  /**
   * @generated from field: repeated string asset_id = 9;
   */
  assetId: string[]

  /**
   * @generated from field: repeated string page_id = 10;
   */
  pageId: string[]

  /**
   * @generated from field: repeated int32 directory_id = 11;
   */
  directoryId: number[]

  /**
   * @generated from field: repeated string tag_name = 12;
   */
  tagName: string[]

  /**
   * @generated from field: bool geo_low_res = 13 [deprecated = true];
   * @deprecated
   */
  geoLowRes: boolean
}

/**
 * Describes the message analytics.v2.GeoScatterPlotRequest.
 * Use `create(GeoScatterPlotRequestSchema)` to create a new message.
 */
export const GeoScatterPlotRequestSchema: GenMessage<GeoScatterPlotRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 59)

/**
 * @generated from message analytics.v2.GeoScatterPlotResponse
 */
export type GeoScatterPlotResponse = Message<'analytics.v2.GeoScatterPlotResponse'> & {
  /**
   * @generated from field: analytics.v2.GeoJson geo_json = 1;
   */
  geoJson?: GeoJson

  /**
   * @generated from field: repeated analytics.v2.ScatterPlotCoordinate plot_points = 2;
   */
  plotPoints: ScatterPlotCoordinate[]
}

/**
 * Describes the message analytics.v2.GeoScatterPlotResponse.
 * Use `create(GeoScatterPlotResponseSchema)` to create a new message.
 */
export const GeoScatterPlotResponseSchema: GenMessage<GeoScatterPlotResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 60)

/**
 * @generated from message analytics.v2.OrgActivityRequest
 */
export type OrgActivityRequest = Message<'analytics.v2.OrgActivityRequest'> & {}

/**
 * Describes the message analytics.v2.OrgActivityRequest.
 * Use `create(OrgActivityRequestSchema)` to create a new message.
 */
export const OrgActivityRequestSchema: GenMessage<OrgActivityRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 61)

/**
 * @generated from message analytics.v2.OrgActivityResponse
 */
export type OrgActivityResponse = Message<'analytics.v2.OrgActivityResponse'> & {
  /**
   * @generated from field: analytics.v2.OrgActivityData data = 1;
   */
  data?: OrgActivityData
}

/**
 * Describes the message analytics.v2.OrgActivityResponse.
 * Use `create(OrgActivityResponseSchema)` to create a new message.
 */
export const OrgActivityResponseSchema: GenMessage<OrgActivityResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 62)

/**
 * @generated from message analytics.v2.ListDataCappedOrgsRequest
 */
export type ListDataCappedOrgsRequest = Message<'analytics.v2.ListDataCappedOrgsRequest'> & {}

/**
 * Describes the message analytics.v2.ListDataCappedOrgsRequest.
 * Use `create(ListDataCappedOrgsRequestSchema)` to create a new message.
 */
export const ListDataCappedOrgsRequestSchema: GenMessage<ListDataCappedOrgsRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 63)

/**
 * @generated from message analytics.v2.ListDataCappedOrgsResponse
 */
export type ListDataCappedOrgsResponse = Message<'analytics.v2.ListDataCappedOrgsResponse'> & {
  /**
   * @generated from field: repeated analytics.v2.OrgActivityData data = 1;
   */
  data: OrgActivityData[]
}

/**
 * Describes the message analytics.v2.ListDataCappedOrgsResponse.
 * Use `create(ListDataCappedOrgsResponseSchema)` to create a new message.
 */
export const ListDataCappedOrgsResponseSchema: GenMessage<ListDataCappedOrgsResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 64)

/**
 * @generated from message analytics.v2.PurgeOrgCacheRequest
 */
export type PurgeOrgCacheRequest = Message<'analytics.v2.PurgeOrgCacheRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string
}

/**
 * Describes the message analytics.v2.PurgeOrgCacheRequest.
 * Use `create(PurgeOrgCacheRequestSchema)` to create a new message.
 */
export const PurgeOrgCacheRequestSchema: GenMessage<PurgeOrgCacheRequest> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 65)

/**
 * @generated from message analytics.v2.PurgeOrgCacheResponse
 */
export type PurgeOrgCacheResponse = Message<'analytics.v2.PurgeOrgCacheResponse'> & {}

/**
 * Describes the message analytics.v2.PurgeOrgCacheResponse.
 * Use `create(PurgeOrgCacheResponseSchema)` to create a new message.
 */
export const PurgeOrgCacheResponseSchema: GenMessage<PurgeOrgCacheResponse> =
  /*@__PURE__*/
  messageDesc(file_analytics_v2_service, 66)

/**
 * Service
 *
 * @generated from service analytics.v2.AnalyticsService
 */
export const AnalyticsService: GenService<{
  /**
   * @generated from rpc analytics.v2.AnalyticsService.HealthCheck
   */
  healthCheck: {
    methodKind: 'unary'
    input: typeof HealthCheckRequestSchema
    output: typeof HealthCheckResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.CompetitiveBenchmarking
   */
  competitiveBenchmarking: {
    methodKind: 'unary'
    input: typeof CompetitiveBenchmarkingRequestSchema
    output: typeof CompetitiveBenchmarkingResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.RangeSummary
   */
  rangeSummary: {
    methodKind: 'unary'
    input: typeof RangeSummaryRequestSchema
    output: typeof RangeSummaryResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.Summary
   */
  summary: {
    methodKind: 'unary'
    input: typeof SummaryRequestSchema
    output: typeof SummaryResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.SummaryPixels
   */
  summaryPixels: {
    methodKind: 'unary'
    input: typeof SummaryPixelsRequestSchema
    output: typeof SummaryPixelsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.Count
   */
  count: {
    methodKind: 'unary'
    input: typeof CountRequestSchema
    output: typeof CountResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.RawEvents
   */
  rawEvents: {
    methodKind: 'unary'
    input: typeof RawEventsRequestSchema
    output: typeof RawEventsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopCodes
   */
  topCodes: {
    methodKind: 'unary'
    input: typeof TopCodesRequestSchema
    output: typeof TopCodesResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopCodesPixels
   */
  topCodesPixels: {
    methodKind: 'unary'
    input: typeof TopCodesPixelsRequestSchema
    output: typeof TopCodesPixelsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopPathsPixels
   */
  topPathsPixels: {
    methodKind: 'unary'
    input: typeof TopPathsPixelsRequestSchema
    output: typeof TopPathsPixelsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopDestinations
   */
  topDestinations: {
    methodKind: 'unary'
    input: typeof TopDestinationsRequestSchema
    output: typeof TopDestinationsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopPages
   */
  topPages: {
    methodKind: 'unary'
    input: typeof TopPagesRequestSchema
    output: typeof TopPagesResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopLinks
   */
  topLinks: {
    methodKind: 'unary'
    input: typeof TopLinksRequestSchema
    output: typeof TopLinksResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopUTMCampaigns
   */
  topUTMCampaigns: {
    methodKind: 'unary'
    input: typeof TopUTMCampaignsRequestSchema
    output: typeof TopUTMCampaignsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopUTMTerms
   */
  topUTMTerms: {
    methodKind: 'unary'
    input: typeof TopUTMTermsRequestSchema
    output: typeof TopUTMTermsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopUTMReferrers
   */
  topUTMReferrers: {
    methodKind: 'unary'
    input: typeof TopUTMReferrersRequestSchema
    output: typeof TopUTMReferrersResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopCities
   */
  topCities: {
    methodKind: 'unary'
    input: typeof TopCitiesRequestSchema
    output: typeof TopCitiesResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopStates
   */
  topStates: {
    methodKind: 'unary'
    input: typeof TopStatesRequestSchema
    output: typeof TopStatesResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopDays
   */
  topDays: {
    methodKind: 'unary'
    input: typeof TopDaysRequestSchema
    output: typeof TopDaysResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopHours
   */
  topHours: {
    methodKind: 'unary'
    input: typeof TopHoursRequestSchema
    output: typeof TopHoursResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopDevices
   */
  topDevices: {
    methodKind: 'unary'
    input: typeof TopDevicesRequestSchema
    output: typeof TopDevicesResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopOperatingSystems
   */
  topOperatingSystems: {
    methodKind: 'unary'
    input: typeof TopOperatingSystemsRequestSchema
    output: typeof TopOperatingSystemsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.TopTags
   */
  topTags: {
    methodKind: 'unary'
    input: typeof TopTagsRequestSchema
    output: typeof TopTagsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.DateRange
   */
  dateRange: {
    methodKind: 'unary'
    input: typeof DateRangeRequestSchema
    output: typeof DateRangeResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.DateRangePixels
   */
  dateRangePixels: {
    methodKind: 'unary'
    input: typeof DateRangePixelsRequestSchema
    output: typeof DateRangePixelsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.Download
   */
  download: {
    methodKind: 'unary'
    input: typeof DownloadRequestSchema
    output: typeof DownloadResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.DownloadRawEvents
   */
  downloadRawEvents: {
    methodKind: 'unary'
    input: typeof DownloadRawEventsRequestSchema
    output: typeof DownloadRawEventsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.GeoAdminLevel
   */
  geoAdminLevel: {
    methodKind: 'unary'
    input: typeof GeoAdminLevelRequestSchema
    output: typeof GeoAdminLevelResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.GeoScatterPlot
   */
  geoScatterPlot: {
    methodKind: 'unary'
    input: typeof GeoScatterPlotRequestSchema
    output: typeof GeoScatterPlotResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.OrgActivity
   */
  orgActivity: {
    methodKind: 'unary'
    input: typeof OrgActivityRequestSchema
    output: typeof OrgActivityResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.ListDataCappedOrgs
   */
  listDataCappedOrgs: {
    methodKind: 'unary'
    input: typeof ListDataCappedOrgsRequestSchema
    output: typeof ListDataCappedOrgsResponseSchema
  }
  /**
   * @generated from rpc analytics.v2.AnalyticsService.PurgeOrgCache
   */
  purgeOrgCache: {
    methodKind: 'unary'
    input: typeof PurgeOrgCacheRequestSchema
    output: typeof PurgeOrgCacheResponseSchema
  }
}> = /*@__PURE__*/ serviceDesc(file_analytics_v2_service, 0)
